// extracted by mini-css-extract-plugin
export default {"ticketWrapper":"ticketMgmtUpdate_ticketWrapper__pCxZa","ticket":"ticketMgmtUpdate_ticket__s8yRW","ticket_btn":"ticketMgmtUpdate_ticket_btn__4Wpem"};